<template>
    <BaseModal
        :id="'static-room-assignments'"
        :title="title"
        :message="room.description"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <div class="col-12 p-0" style="margin-top:20px;">
                <div class="w-100 table-responsive overflow-y--1">
                    <table class="table">
                        <thead style="background-color: #f1f1f1;">
                            <tr>
                                <th style="padding-top:25px" v-for="(item, i) in table_headers" :key="i" scope="col" v-html="item.name"/>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in assignments" :key="i">
                                <td>
                                    <span v-if="item.status == 1" class="text-weight-medium text-success">Active</span>
                                    <span v-else class="text-weight-medium text-secondary">Inactive</span>
                                </td>
                                <td>
                                    <a :href="`/assignment-daily-assignments/${item.id}`" v-html="item.description"/>
                                </td>
                                <td v-html="item.task_name"/>
                                <td v-html="item.frequency"/>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal__buttons text-center text-md-right">
                    <button type="button" class="modal__buttons__item cancel" data-dismiss="modal" aria-label="Close" v-html="'Cancel'"/>
                    <a :href="`/building-room/${room.id}`" class="modal__buttons__item" v-html="`Go to room record`"/>
                </div>
            </div>
        </template>
    </BaseModal>
</template>

<style scoped>
    .black-label{
        color:black;
    }
</style>

<script>

import Resources  from './resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal  from '@/components/BaseModal'

export default {

    name: "FormModalMove",

    props: [
        'title',
        'breadcrumb',
        'room',
        'assignments',
    ],

    components:{
        Breadcrumb,
        BaseModal,
    },

    data(){
        return{
            table_headers: Resources.lite_assignment_table_headers
        }
    },

    watch: {

    },

    methods: {
    },

  mounted(){},

};
</script>